import axios from "axios";
import { EventFilter } from "./Types";
import { authStore } from "../store/authStore";
import { message } from "antd";
import Constants from "../constants/Common";

export default {
  getInfoPane(filter: EventFilter) {
    return axios.get("/sp/event/infopane", { params: filter });
  },
  getRegistry(page: number, count: number, filter: EventFilter) {
    return axios.get(`/sp/event/SearchMap?page=${page}&count=${count}`, {
      params: {
        ...filter,
        organizationIds: [Number(localStorage.getItem("userOrgId"))],
      },
    });
  },
  getBriefCard(id: number) {
    return axios.get(`/sp/event/${id}/brief`, {});
  },
  getFullCard(id: number) {
    // return axios.get(`/sp/event/${id}/full`, {});
    return axios.get(`/sp/event/${id}`, {});
  },
  export(filter: EventFilter) {
    const options = { responseType: "blob", params: filter };
    debugger;
    // @ts-ignore
    return axios
      .get("/sp/DefectReports/ExportMapToExcel", options)
      .then((response) => {
        const blob = new Blob([response.data], { type: response.data.type });
        const link = document.createElement("a");
        const contentDisposition = response.headers["content-disposition"];
        let filename = "defects";
        if (contentDisposition) {
          const matches = contentDisposition.match(/filename=([\w\d\-_.]+)/);
          if (matches.length === 2) {
            filename = matches[1];
          }
        }
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        URL.revokeObjectURL(link.href);
      });
  },
  exportExcelThread(filter: EventFilter) {
    const options = { responseType: "blob", params: filter };
    return axios
      .get("/sp/DefectReports/ExportMapToExcel/threaded", options)
      .then((response) => {
        message.success(Constants.statusMessage.downloadRequestSent);
      });
  },
  getOrganizations(id?) {
    if (id) {
      return axios.get(`/sp/event/organizations?gridTypeId=${id}`, {});
    } else {
      return axios.get(`/sp/event/organizations`, {});
    }
  },
  getRsoOrganizations(url = "Event/SearchSpRsoItems") {
    return axios.get(`/sp/${url}`);
  },
  updateRsoOrganizations(payload, url = "Event/UpdateSpRsoItems") {
    return axios.put(`/sp/${url}`, payload);
  },
};
